import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 19.93 17.794"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("defs", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("g", {
  id: "Group_4006",
  "data-name": "Group 4006",
  transform: "translate(-2 -3)"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    id: "Path_7916",
    "data-name": "Path 7916",
    class: "cls-1",
    d: "M20.506 21v3.559H3.424V21H2v3.559a1.424 1.424 0 0 0 1.424 1.424h17.082a1.424 1.424 0 0 0 1.424-1.424V21z",
    transform: "translate(0 -5.188)"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    id: "Path_7917",
    "data-name": "Path 7917",
    class: "cls-1",
    d: "m14.214 18.161 5.175-5.466h-2.848V7h-5.694v5.694H8l5.16 5.459a.712.712 0 0 0 1.053.007z",
    transform: "translate(-1.729 -1.153)"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    id: "Path_7918",
    "data-name": "Path 7918",
    class: "cls-1",
    d: "M17.694 3H12v1.424h5.694z",
    transform: "translate(-2.882)"
  })
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render };